<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-11-20 11:15:40
 * @LastEditors: lijingjing56
 * @LastEditTime: 2024-12-17 14:22:13
-->
<template>
  <div class="product-service-section-container">
      <section-title :text="title" :btn="{text:'加入我们',center:true,router:'/cloud/about/us'}" />
      <div class="section-main">
          <div v-for="data in dataList" :key="data.name" :class="'cls-item'">
              <div class="item-one-row">
                  <img class="item-img" :src="data.source">
                  <div class="item-name">{{data.name}}</div>
              </div>
              <div class="item-content">{{data.describe}}</div>
            </div>
      </div>
  </div>
</template>

<script>
import sectionTitle from "./sectionTitle.vue";
export default {
name: "JoinList",
components: {
  sectionTitle
},
props: {
  title: {
    type: String,
    default: ""
  },
  dataList: {
      type: Array,
      default: []
    },
}
};
</script>

<style lang="scss" scoped>
.product-service-section-container {
width: 100%;
padding: 80px 0 56px;
background-color: #ffffff;

.section-main {
  width: 1268px;
  margin: 39px auto 0;
  display: flex;
  justify-content: center;
  .cls-item {
    width: 384px;
    height:445px;
    border-radius: 12px;
    background: linear-gradient(180deg, rgba(240, 242, 255, 1) 0%, rgba(251, 252, 255, 1) 48.13%, rgba(255, 255, 255, 1) 100%);
    box-shadow: 0px 1px 10px 5px rgba(255, 255, 255, 0.5) inset;
    margin-right: 32px;

    .cls-img {
      width: 128px;
      height: 107px;
      display: block;
      margin: 0 auto;
    }
    .item-one-row {
      margin-top: 40px;
      text-align: center;
      .item-img{
        width: 150px;
      }
      .item-name {
        font-size: 32px;
        font-weight: 500;
        color: #000;
        margin: 30px auto 16px;
      }
    }

    .item-content {
      font-size: 16px;
      font-weight: 400;
      color: #888;
      width: 306px;    
      margin: auto;
      line-height:25px;
    }
  }
}
}
</style>

